import { z } from 'zod';

export const GetEDDStatusResultSchema = z.object({
  status: z.string(),
  kyc_address: z.object({
    address_line_1: z.string(),
    address_line_2: z.string(),
    city: z.string(),
    state: z.string().nullable(),
    postcode: z.string(),
    country: z.string(),
  }),
  kyc_processes: z.object({
    proof_of_address: z.object({
      submit_required: z.boolean(),
    }),
  }),
});

export type GetEDDStatusResult = z.infer<typeof GetEDDStatusResultSchema>;

export interface GetEDDStatusParams {}
